import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';

function SiteMap(props) {
  return <ContentPage {...props} />;
}

export async function getStaticProps() {
  return {
    props: {
      sitepageid: 601,
    },
  };
}

export default SiteMap;
